export default __webpack_public_path__ + "static/O0069-7555c4b4e84d91b65aeb6c0dbf864355.png";